import React from 'react';
import Select from 'react-select';
import { useSelectStyles } from '../../utils/selectStyles';
import DateRangeSelector from '../DateRangeSelector';

const GIFormFilters = ({
  answerRangeStartDate,
  answerRangeEndDate,
  initialAnswerRangeStartDate,
  initialAnswerRangeEndDate,
  onAnswerRangeChange,
  showReset = false,
  onResetAll,
  dateOptions,
  promoterOptions,
  shopSignOptions,
  interventionPointOptions,
  selectedDates,
  selectedPromoters,
  selectedShopSigns,
  selectedInterventionPoints,
  onDateFilterChange,
  onPromoterFilterChange,
  onShopSignFilterChange,
  onInterventionPointFilterChange,
  onClearAllFilters
}) => {
  const selectStyles = useSelectStyles();

  return (
    <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">Filtres</h3>
        {showReset && typeof onResetAll === 'function' && initialAnswerRangeStartDate && initialAnswerRangeEndDate && (
          <button
            type="button"
            onClick={onResetAll}
            className="text-sm text-blue-600 dark:text-blue-300 hover:underline"
          >
            Reset
          </button>
        )}
      </div>

      {/* Answer date range (applies before day selection) */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Période
        </label>
        <DateRangeSelector
          startDate={answerRangeStartDate}
          endDate={answerRangeEndDate}
          onDatesChange={onAnswerRangeChange}
          relative={false}
          includeFuture={false}
          maxDateRange={{ value: 5, unit: 'years' }}
        />
      </div>

      {/* Stack fields vertically for better readability in sidebar */}
      <div className="grid grid-cols-1 gap-4">
        {/* Filtre par date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Jour ({dateOptions.length})
          </label>
          <Select
            isMulti
            value={selectedDates}
            onChange={onDateFilterChange}
            options={dateOptions}
            styles={selectStyles}
            placeholder="Sélectionner des jours..."
            noOptionsMessage={() => "Aucun jour disponible"}
            className="text-sm"
          />
        </div>

        {/* Filtre par promoteur */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Promoteur ({promoterOptions.length})
          </label>
          <Select
            isMulti
            value={selectedPromoters}
            onChange={onPromoterFilterChange}
            options={promoterOptions}
            styles={selectStyles}
            placeholder="Sélectionner des promoteurs..."
            noOptionsMessage={() => "Aucun promoteur disponible"}
            className="text-sm"
          />
        </div>

        {/* Filtre par enseigne */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Enseigne ({shopSignOptions.length})
          </label>
          <Select
            isMulti
            value={selectedShopSigns}
            onChange={onShopSignFilterChange}
            options={shopSignOptions}
            styles={selectStyles}
            placeholder="Sélectionner des enseignes..."
            noOptionsMessage={() => "Aucune enseigne disponible"}
            className="text-sm"
          />
        </div>

        {/* Filtre par point d'intervention */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Point d'intervention ({interventionPointOptions.length})
          </label>
          <Select
            isMulti
            value={selectedInterventionPoints}
            onChange={onInterventionPointFilterChange}
            options={interventionPointOptions}
            styles={selectStyles}
            placeholder="Sélectionner des points..."
            noOptionsMessage={() => "Aucun point d'intervention disponible"}
            className="text-sm"
          />
        </div>
      </div>

      {/* Indicateurs de filtres actifs */}
      {(selectedDates.length > 0 || selectedPromoters.length > 0 || selectedInterventionPoints.length > 0 || selectedShopSigns.length > 0) && (
        <div className="mt-4 flex flex-wrap items-center gap-2">
          <span className="text-sm text-gray-600 dark:text-gray-400">Filtres actifs:</span>
          {selectedDates.length > 0 && (
            <span className="bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-2 py-1 rounded text-xs">
              {selectedDates.length} jour{selectedDates.length > 1 ? 's' : ''}
            </span>
          )}
          {selectedPromoters.length > 0 && (
            <span className="bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 px-2 py-1 rounded text-xs">
              {selectedPromoters.length} promoteur{selectedPromoters.length > 1 ? 's' : ''}
            </span>
          )}
          {selectedShopSigns.length > 0 && (
            <span className="bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200 px-2 py-1 rounded text-xs">
              {selectedShopSigns.length} enseigne{selectedShopSigns.length > 1 ? 's' : ''}
            </span>
          )}
          {selectedInterventionPoints.length > 0 && (
            <span className="bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-200 px-2 py-1 rounded text-xs">
              {selectedInterventionPoints.length} point{selectedInterventionPoints.length > 1 ? 's' : ''}
            </span>
          )}
          <button
            onClick={onClearAllFilters}
            className="text-xs text-red-600 dark:text-red-400 hover:underline ml-2"
          >
            Effacer tous les filtres
          </button>
        </div>
      )}
    </div>
  );
};

export default GIFormFilters;